import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorTimeline, } from '@zurich/ui/legacy/components';
import { useAppInstance } from '../../hooks';
export function NextAppErrorDetails({ error }) {
    const { errorViewHandler, createErrorObject } = useAppInstance();
    return (_jsx(ErrorTimeline, { error: error, errorViewHandler: errorViewHandler, createErrorObject: createErrorObject }));
}
